import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

/**
* Reducer
*/
import reducer from './reducers';

/**
* Sagas
*/
import rootSagas from './sagas';

const resetSpinnersTransform = createTransform(
    // transform state on its way to being serialized and persisted.
    (inboundState) => inboundState,
    // transform state being rehydrated
    (outboundState) => {
        if (!outboundState || typeof outboundState !== 'object') return outboundState;
        const newState = { ...outboundState };
        Object.keys(newState).forEach((k) => {
            if (
                typeof k === 'string'
                && (k.toLowerCase().includes('fetching')
                    || k.toLowerCase().includes('loading')
                    || k.toLowerCase().includes('pending')
                    || k.toLowerCase().includes('initialising'))
            ) {
                if (typeof newState[k] === 'boolean') {
                    newState[k] = false;
                }
            }
        });
        return newState;
    },
);

/**
 * ## configureStore
 * @param {Object} the state
 */
const persistConfig = {
    key: 'root',
    storage,
    // 250317 YUANKUI: FIX THX-153: Page doesn't load until this has updated to make it clearer
    //                 Prevent the kpi reducer's state from being persisted
    blacklist: ['kpi'],
    transforms: [resetSpinnersTransform],
};
const persistedReducer = persistReducer(persistConfig, reducer);

export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware();
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line

    const store = createStore(
        persistedReducer,
        initialState,
        composeEnhancers(applyMiddleware(
            sagaMiddleware,
            thunk,
        )),
    );

    const persistor = persistStore(store);

    sagaMiddleware.run(rootSagas);

    return { store, persistor };
}
